export const BodyContent = {
  title: {
    zh: "会员快捷支付如何使用",
    en: "How To Use",
  },
  leftLabel: {
    zh: "会员登录",
    en: "Member Login",
  },
  phoneDes: {
    zh: "手机号验证加入会员",
    en: "Mobile phone number verification to join a member",
  },
  codeDes: {
    zh: "服务员扫码支付享受折扣",
    en: "Waiter scan QR code to enjoy discount",
  },
  codeNoDiscountDes: {
    zh: "服务员扫码支付",
    en: "Waiter scan QR code",
  },
  cardDes: {
    zh: "会员可直接登录查看会员余额",
    en: "Members can log in directly to view the member balance",
  },
  joinBtn: {
    zh: "免费加入会员",
    en: "Free To Join",
  },
  notFreeJoinBtn: {
    zh: "加入会员",
    en: "Join membership",
  },
  agreeCheck: {
    zh: "已阅读并同意",
    en: "Agree to the membership",
  },
  agreeLink: {
    zh: "会员服务条款",
    en: "terms of service",
  },
  agreeTip: {
    zh: "请先阅读chowbus隐私政策",
    en: "Please read the chowbus Privacy Policy first",
  },
  forbiddenRegisterTips: {
    zh: '请联系服务员，立即加入会员',
    en: 'Please contact the waiter and join the membership immediately'
  }
};

export const BannerContent = {
  title: {
    zh: "",
    en: "Welcome to join restaurant name restaurant name would be very long",
  },
};

export const formPlaceholder = {
  join: {
    name: {
      zh: "请输入你的名字",
      en: "Please input your name",
    },
    phone: {
      zh: "请输入手机号",
      en: "Please input your phone number",
    },
    phoneInValid: {
      zh: "请输入正确的手机号",
      en: "Please input the correct phone number",
    },
    btn: {
      zh: "继续",
      en: "Next",
    },

    email: {
      zh: "输入邮箱(非必填)",
      en: "Please enter your email (Optional)",
    },
    birthday: {
      zh: "选择生日(非必填)",
      en: "Please enter birthday (Optional)",
    },
  },
  verify: {
    phone: {
      zh: "请输入短信验证码",
      en: "Please input verification code",
    },
    btn: {
      zh: "验证",
      en: "Verify",
    },
  },
  login: {
    phone: {
      zh: "请输入手机号",
      en: "Please input your phone number",
    },
    phoneInValid: {
      zh: "请输入正确的手机号",
      en: "Please input the correct phone number",
    },
    btn: {
      zh: "继续",
      en: "Next",
    },
  },
};

export const BtnText = {
  btnSending: {
    zh: "发送中...",
    en: "sending...",
  },
};

// readme config
export const RestaurantConfig = {
  title: {
    zh: "返回",
    en: "Back",
  },
};

export const VerifyTipConfig = {
  msg: {
    zh: "验证码发送成功.",
    en: "The verification code has been sent successfully.",
  },
  msgError: {
    zh: "验证码发送失败",
    en: "Something went wrong when sending verification code.",
  },
  join: {
    zh: "恭喜，注册成功~",
    en: "Congratulations, you have successfully registered.",
  },
  error: {
    zh: "手机号码错误，请重新输入",
    en: "Phone number is invalid, please re-enter.",
  },
  verifyError: {
    zh: "手机号或验证码无效",
    en: "Invalid phone number or verification code.",
  },
  phoneError: {
    zh: "当前仅支持+1手机号，如有疑问，请联系客服，谢谢",
    en:
      "We're sorry, only valid mobile +1 numbers are supported at this time. If you believe this is in error, please reach out to customer service.",
  },
  phoneError2: {
    zh: "请求被拒绝，请联系客服",
    en:
      "Request denied. Please contact customer service for further assistance.",
  },
  registerError: {
    zh: "用户名或手机号缺失",
    en: "The user's name or phone number is msssing.",
  },
};

export const RestaurantWarnTips = {
  error: {
    zh: "请先注册餐厅会员",
    en: "Please register first.",
  },
  contractError: {
    zh: "没有配置充值列表!",
    en: "No prepaid list found! ",
  },
};

export const RestaurantCardDatas = {
  btnText: {
    zh: "加入 Apple Wallet 即享折扣",
    en: "Add to Apple Wallet to enjoy discount",
  },
  btnBottomText: {
    zh: "以免会员卡丢失，请保存卡到Apple Wallet",
    en: "In case of losing this card, please add to Apple Wallet",
  },
  recharge: {
    zh: "去充值，最高返",
    en: "Add Balance, Unlock Up to ",
  },
  rechargeZero: {
    zh: "去充值",
    en: "Add Balance",
  },
  rechargeJoin: {
    zh: '充值任意金额激活会员',
    en: 'Reload any amount to activate',
  },
  annualJoin: {
    zh: ['支付', '年费激活会员'],
    en: ['Pay annual fee ', ' to activate'],
  },
  annualExpiredJoin: {
    zh: ['', '续费年费会员'],
    en: ['Renew membership', ''],
  },

};

export const OrderHistoryTitle = {
  zh: "历史订单",
  en: "Order History",
};

export const OrderListDatas = {
  restaurantId: {
    zh: "",
    en: "",
  },
  restaurantName: {
    zh: "",
    en: "",
  },
  restaurantForeignName: {
    zh: "",
    en: "",
  },
  orderId: {
    zh: " 订单号 ",
    en: " Order# ",
  },
  time: {
    zh: "",
    en: "",
  },
  billTotal: {
    zh: "账单总计",
    en: "Bill Total",
  },
  tips: {
    zh: "小费",
    en: "Tips",
  },
  cashbackRedeemed: {
    zh: "会员账户余额",
    en: "Loyalty Credit",
    prefix: "-",
  },
  totalPaid: {
    zh: "实付金额",
    en: "Total Paid",
  },
  totalAmountPaid: {
    zh: "实付金额",
    en: "Total Amount Paid",
  },
  totalAmountCredited: {
    zh: "充值总额",
    en: "Total Amount Credited",
  },
  cashbackIssued: {
    zh: "发出返现",
    en: "Cashback Issued",
  },
  paymentType: {
    zh: "",
    en: "",
  },
  reChargeAmount: {
    zh: "充值金额",
    en: "Recharge Amount",
  },
  freeAmount: {
    zh: "赠送金额",
    en: "Free Amount",
    prefix: "+",
  },
  balance: {
    zh: "余额",
    en: "Balance",
  },
  orderType: {
    zh: "",
    en: "",
  },
  rchargeTotal: {
    zh: "充值总额",
    en: "Total Amount",
  },
  timestamp: {
    zh: "",
    en: "",
  },
  paymentDetails: {
    zh: "支付明细",
    en: "Payment Methods",
  },
  payment_details_card: {
    zh: "支付 - 信用卡",
    en: "Card",
  },
  payment_details_gift_card_v2: {
    zh: "支付 - 礼品卡",
    en: "Gift Card",
  },
  payment_details_card_present: {
    zh: "支付 - 信用卡",
    en: "Card_present",
  },
  payment_details_cash: {
    zh: "支付 - 现金",
    en: "Cash",
  },
  payment_details_compensation: {
    zh: "支付 - 补偿",
    en: "Compensation",
  },
  payment_details_cashback: {
    zh: "支付 - 返现抵扣",
    en: "Cashback",
  },


};

export const paymentTypeMap = {
  card: {
    zh: "信用卡",
    en: "Card",
  },
  card_present: {
    zh: "信用卡",
    en: "Card_present",
  },
  cash: {
    zh: "现金",
    en: "Cash",
  },
  compensation: {
    zh: "补偿",
    en: "Compensation",
  },
  cashback: {
    zh: "返现抵扣",
    en: "Cashback",
  },
  gift_card_v2: {
    zh: "礼品卡",
    en: "Gift Card",
  },
};

export const orderListTip = {
  zh: "没有更多了",
  en: "Nothing more",
};

export const orderListEmpty = {
  zh: "没有订单数据",
  en: "No Data",
};

export const PayContent = {
  payTitlePre: {
    zh: "会员充值享返利",
    en: "Add Balance",
  },
  payEnOnlyPre: {
    en: "Add more, get more",
    zh: "",
  },
  payTitleAfter: {
    zh: " 最高返",
    en: ", Unlock up to ",
  },
  payItemPre: {
    zh: "单次充值",
    en: "Pay ",
  },
  payItemAfter: {
    zh: "送",
    en: "Get",
  },
  payItemAfterTail: {
    zh: "",
    en: " Bonus",
  },
};


export const BirthdayContent = {
  title: {
    zh: '请选择输入你的生日',
    en: 'Please enter your birthday',
  },
  please_select_year: {
    zh: '--年--',
    en: '--Year--',
  },
  please_select_month: {
    zh: '--月--',
    en: '--Month--',
  },
  please_select_day: {
    zh: '--日--',
    en: '--Day--',
  },
  confirm_button: {
    zh: '确认',
    en: 'Confirm',
  },
  cancel_button: {
    zh: '取消',
    en: 'Cancel',
  }
}


export const RestaurantListOnGroupTitle = {
  zh: "适用门店",
  en: "Applicable store",
};